import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {plainToClass} from "class-transformer";
import {DtoManagementEmployeeFilter} from "./models/DtoManagementEmployeeFilter";
import {DtoManagementEmployee} from "./models/DtoManagementEmployee";

@Injectable()
export class EmployeeInfoService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getEmployeeInfo = (filter: DtoManagementEmployeeFilter): Observable<DtoManagementEmployee[]> => {
        return this.http.post<DtoManagementEmployee[]>(`${this.apiUrl}/employeeinfo/`, filter);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/employee-info/employee-info.service.ts